module.exports = __webpack_public_path__ + "img/SKMJ_check5.11eab709.png";